import React, { Component } from "react";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@material-ui/icons/Add";
import { Autocomplete } from "@mui/material";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import SmsContactImportFile from "../../../assets/importTemplate/SmsContact_Import.csv";
import {
  CreateGroup_Url,
  DeleteGroup_Url,
  GroupList_Url,
  ImportContacts_Url,
  UpdateGroup_Url,
  UserList_Url,
} from "../../../provider/ServiceUrl";
import PtsAlert from "../ptsAlert/PtsAlert";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import "./GroupList.css";
import _ from "lodash";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import CreateButton from "../buttons/CreateButton";
import CancelIconButton from "../buttons/CancelIconButton";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import LinearProgressWithLabel from "../popUp/LinearProgressWithLabel ";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import Pagination from "../pagination/Pagination";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
class GroupList extends Component {
  header = store.getState().header.header;
  groupState = store.getState().applicationState.groupState;
  accountSettings = store.getState().accountSetting?.accountSetting;
  companyName =
    store.getState().appUserData.appUserData.appuser?.organization?.name;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  paginationState = store.getState().paginations.groupsState;
  groupStateDetails = {};
  paginationStateDetails = {};
  breadCrumb = [{ pageid: "", uiname: "Groups" }];
  title = "Create and manage texting groups";
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    if (this.groupState) {
      this.groupStateDetails = Object.getOwnPropertyNames(this.groupState);
    }

    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }

    if (this.groupStateDetails.length > 0) {
      this.state = {
        groupName: "",
        pageNo: this.groupState.pageNo,
        pageSize: this.groupState.pageSize,
        groupId: this.groupState.groupId,
        smsGroupList: [],
        importSmsGroupList: [],
        skippedNumbers: [],
        selectedFile: { name: "" },
        groupsName: null,
        open: false,
        isImportOpen: false,
        checkCSVFile: false,
        isPaging: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        iscreateGroup: false,
        render: false,
        isDragging: false,
        isProgress: false,
        isImportDisableOpen: false,
        openSkippedNumbers: false,
        progress: 0,
        sortColumn: this.groupState.sortColumn,
        isAscSort: this.groupState.isAscSort,
        sortDirection: "asc",
        groupCreatedBy: null,
        searchText: "",
      };
    } else {
      this.state = {
        pageNo: 0,
        pageSize:
          this.paginationStateDetails?.length > 0
            ? this.paginationState?.pageSize
            : 20,
        groupName: "",
        groupId: "",
        groupsName: null,
        smsGroupList: [],
        importSmsGroupList: [],
        skippedNumbers: [],
        selectedFile: { name: "" },
        open: false,
        isImportOpen: false,
        checkCSVFile: false,
        isPaging: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        iscreateGroup: false,
        render: false,
        isDragging: false,
        isProgress: false,
        isImportDisableOpen: false,
        openSkippedNumbers: false,
        progress: 0,
        sortColumn: this.paginationStateDetails?.length > 0
          ? this.paginationState?.sortColumn : null,
        isAscSort: this.paginationStateDetails?.length > 0
          ? this.paginationState?.isAscSort : false,
        sortDirection: "asc",
        groupCreatedBy: null,
        searchText: "",
      };
    }
    this.getGroupList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getGroupList, 800);
  }
  // componentDidMount() {
  //   this.timer = setInterval(() => {
  //     this.setState((prev) => {
  //       const next = Math.min(prev.progress + 10, 100);
  //       if (next === 100) clearInterval(this.timer);
  //       return { progress: next };
  //     });
  //   }, 300);
  // }

  componentWillUnmount() {
    clearInterval(this.timer);
  }
  getGroupList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          let smsCredits = output.data.smsCredits;
          let accountSetting = output.data.accountSetting;
          let page = output.data.page;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          // let isPaging = false;
          let importSmsGroupList = [];

          if (smsCredits !== null) {
            const { showCardexpiryMessage, ...smsCreditsWithoutFlag } = smsCredits;

            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCreditsWithoutFlag)
              );
            } else {
              store.dispatch(
                AppUserDataAction.setUsage(smsCreditsWithoutFlag)
              );
            }
          }
          store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
          for (let i = 0; i < smsGroupList.length; i++) {
            smsGroupList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(smsGroupList[i].createdOn) : Utils.getUtcToLocal(
              smsGroupList[i].createdOn
            );
            smsGroupList[i].updatedOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(smsGroupList[i].updatedOn) : Utils.getUtcToLocal(
              smsGroupList[i].updatedOn
            );
          }

          importSmsGroupList.unshift(
            {
              name: "Create new group",
              id: "Create new group",
            },
            ...smsGroupList
          );

          this.setState({
            render: true,
            groupName: "",
            open: false,
            selectedFile: { name: "" },
            groupsName: null,
            isImportOpen: false,
            checkCSVFile: false,
            // isPaging: isPaging,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            smsGroupList: smsGroupList,
            importSmsGroupList: importSmsGroupList,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      }
    );
  }

  addGroup() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventGroup", {
        state: {
          action: "create",
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextGroup", {
        state: {
          action: "create",
        },
      });
    } else {
      this.props.navigate("/group", {
        state: {
          action: "create",
        },
      });
    }
  }

  toGroupDetails(e, data) {
    if (e.target.closest(".action-button")) {
      return; // skip preview if clicking action buttons
    }
    let groupState = {
      groupId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(ApplicationStateAction.setApplicationState({ groupState }));
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventGroup", {
        state: {
          action: "view",
          groupId: data.id,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextGroup", {
        state: {
          action: "view",
          groupId: data.id,
        },
      });
    } else {
      this.props.navigate("/group", {
        state: {
          action: "view",
          groupId: data.id,
        },
      });
    }
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ pageNo: page, pageSize: pageSize });
  }

  handleImportDropdownClose = () => {
    this.setState({
      isImportOpen: false,
      anchorEl: null,
      checkCSVFile: false,
      selectedFile: { name: "" },
      groupName: "",
      groupsName: null,
    });
  };

  handleSkippedNumbersClose = () => {
    this.setState({
      openSkippedNumbers: false,
    });
  };

  handleImportDropdownOpen = (e) => {
    this.setState({
      isImportOpen: true,
      anchorEl: e.currentTarget,
      progress: 0,
      isProgress: false,
    });
  };

  checkCSVFilekHandler(e) {
    this.setState({ checkCSVFile: e.target.checked });
  }
  cancelImportExcelFile() {
    this.setState({
      selectedFile: { name: "" }
    })
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.onFileChange(file);
    }
  };
  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.onFileChange(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  onFileChange = (file) => {
    // const file = event.target.files[0];

    if (file) {
      const fileName = file.name.toLowerCase();

      // Validate file extension
      if (!fileName.endsWith(".csv")) {
        PtsAlert.error("Please upload valid CSV file.");
        this.setState({ selectedFile: { name: "" } });
        return;
      }

      // Update state if valid file is selected
      this.setState({ selectedFile: file });
    }
  };

  excelImportContactToGroup = () => {
    this.setState({ isProgress: true, progress: 0 });

    if (!this.state.selectedFile?.name) {
      PtsAlert.error("Please select file to upload");
      this.setState({ isProgress: false });
      return;
    }

    const header = store.getState().header.header;
    const formData = new FormData();

    formData.append("file", this.state.selectedFile, this.state.selectedFile.name);
    formData.append("sessionid", header.sessionid);
    formData.append("tid", header.tid);
    formData.append("userid", header.userid);
    formData.append("appclient", header.appclient);
    formData.append("isAp", header.isAp);
    formData.append("groupId", this.state.groupId);
    formData.append("groupName", this.state.groupName);
    formData.append("iscreategGroup", this.state.iscreateGroup);
    formData.append("eventId", this.businessDomainId);

    FetchServerData.callPostFileUpload(ImportContacts_Url, formData, {
      timeout: 0,
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;

        // Upload progress → 0–60%
        const uploadPercent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        const mapped = Math.min(60, Math.round(uploadPercent * 0.6));
        this.setState({ progress: mapped });
      },
    })
      .then((output) => {
        this.stopPendingProgress();

        if (output.status === "SUCCESS") {
          const skippedNumbers =
            output?.data?.smsGroup?.skippedNumbers || [];

          this.setState({ progress: 100 }, () => {
            setTimeout(() => {
              this.setState({
                isProgress: false,
                isImportOpen: false,
              });

              if (skippedNumbers.length > 0) {
                this.setState({
                  openSkippedNumbers: true,
                  skippedNumbers,
                });
              }

              this.getGroupList(
                this.state.pageNo,
                this.state.pageSize,
                this.state.sortColumn,
                this.state.isAscSort
              );
            }, 800);
          });
        } else {
          this.setState({ isProgress: false });
        }
      })
      .catch(() => {
        this.stopPendingProgress();
        this.setState({ isProgress: false });
        PtsAlert.error("Import failed");
      });

    this.startPendingProgress();
  };

  startPendingProgress = () => {
    this.pendingTimer = setInterval(() => {
      this.setState((prev) => {
        if (prev.progress >= 90) return null;
        return { progress: prev.progress + 1 };
      });
    }, 700);
  };

  stopPendingProgress = () => {
    if (this.pendingTimer) {
      clearInterval(this.pendingTimer);
      this.pendingTimer = null;
    }
  }
  handleCreateGroupChange(e) {
    this.setState({ iscreateGroup: e.target.checked, groupId: "" });
  }

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
    });
  }

  handleGroupCreatedByChange(selectedValue) {
    this.setState({
      groupCreatedBy: selectedValue
    })
  }

  handleGroupsNameChange(selectedValue) {
    if (selectedValue.name === "Create new group") {
      this.setState({
        groupsName: selectedValue,
        groupId: "",
        iscreateGroup: true,
      });
    } else {
      this.setState({
        groupsName: selectedValue,
        groupId: selectedValue?.id,
        iscreateGroup: false,
      });
    }
  }

  handleAddGroupOpen() {
    this.setState({
      open: true,
      action: "create",
      groupName: "",
      groupId: "",
    });
  }

  handleEditGroupOpen(data) {
    this.getUserList();
    this.setState({
      open: true,
      action: "edit",
      groupName: data.name,
      groupId: data.id,
    });
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }

  getUserList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(UserList_Url, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        let userList = output.data.appuserList;
        this.setState({
          render: true,
          userList: userList,
        });
      } else {
      }
    });
  }

  deleteGroupToBackend(data) {
    const postObject = {
      header: this.header,
      smsGroup: {
        id: data.id,
      },
    };

    FetchServerData.callPostService(DeleteGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getGroupList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        } else {
        }
      })
      .catch((error) => { });
  }

  createGroupToBackend() {
    const postObject = {
      header: this.header,
      smsGroup: {
        name: this.state.groupName,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(CreateGroup_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let groupDetails = output.data.smsGroup;
          // this.getGroupList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);

          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            this.props.navigate("/eventGroup", {
              state: {
                action: "view",
                groupId: groupDetails?.id,
              },
            });
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.props.navigate("/dptextGroup", {
              state: {
                action: "view",
                groupId: groupDetails?.id,
              },
            });
          } else {
            this.props.navigate("/group", {
              state: {
                action: "view",
                groupId: groupDetails?.id,
              },
            });
          }
        } else {
        }
      }
    );
  }

  updateGroupToBackend() {
    const postObject = {
      header: this.header,
      smsGroup: {
        name: this.state.groupName,
        id: this.state.groupId,
        createdBy: this.state.groupCreatedBy?.id,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(UpdateGroup_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getGroupList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        } else {
        }
      }
    );
  }

  showActionButton(rowData) {
    return (
      <>
        <div className="row d-flex" style={{ float: "center" }}>
          <div className="col-md-12 d-flex">
            {this.state.getUpdatePermission && (
              <span style={{ cursor: "pointer" }}>
                <EditButton onClick={() => this.handleEditGroupOpen(rowData)} />
              </span>
            )}
            <span className="ps-2" style={{ cursor: "pointer" }}>
              {this.state.getDeletePermission && (
                <Tooltip title="Delete" classes={{ popper: "custom-tooltip" }}>
                  <DeleteButton
                    domainObject={rowData.name}
                    pageId="Group"
                    onClick={() => this.deleteGroupToBackend(rowData)}
                  />
                </Tooltip>
              )}
            </span>
          </div>
        </div>
      </>
    );
  }

  handleImportDisableOpen() {
    this.setState({
      isImportDisableOpen: true,
    });
  }
  handleImportDisableClose() {
    this.setState({
      isImportDisableOpen: false,
    });
  }
  requestActivateImportContact() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/supportms/requestActivateImportContact",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          isImportDisableOpen: false,
        });
      } else {
      }
    });
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const groupsState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setGroupsPaginationState({ groupsState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getGroupList(currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const groupsState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setGroupsPaginationState({ groupsState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getGroupList(pageNo, pageSize, column, isAscSort);
      }
    );
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
          pageId="Group"
        />
        <div className="row">
          <div className="col md-12">
            <div className="card rounded-0">
              <div
                className="row justify-content-between"
                style={{ padding: "0.6em 1.2rem" }}
              >
                <div className="d-flex col-12 col-lg-9 col-xl-9">
                  <div className="col-12 d-flex">
                    {this.state.getCreatePermission && (
                      <>
                        <Button
                          id="ptsGreenSolidButton"
                          type="button"
                          variant="contained"
                          startIcon={<AddIcon style={{ fontWeight: "600" }} />}
                          onClick={() => this.handleAddGroupOpen()}
                        >
                          Add Group
                        </Button>
                        &nbsp; &nbsp;
                        <Button
                          id="ptsSolidButton"
                          variant="contained"
                          type="button"
                          startIcon={
                            <UploadFileIcon />
                          }
                          onClick={(event) => {
                            this.accountSettings?.enableImport
                              ? this.handleImportDropdownOpen(event)
                              : this.handleImportDisableOpen(event);
                          }}
                        >
                          Import Contacts
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <div className="d-flex col-12 col-lg-3 col-xl-3 text-end align-self-center">
                  <div className="col-sm-12 text-end align-self-center">
                    <span className="me-1">
                      <TextField
                        id="standard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        style={{ width: "193px" }}
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.getGroupList.bind(
                                  this,
                                  this.state.pageNo,
                                  this.state.pageSize
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  this.setState({ searchText: "" }, () => {
                                    this.getGroupList(
                                      this.state.pageNo,
                                      this.state.pageSize
                                    );
                                  });
                                }}
                                disabled={!this.state.searchText}
                              >
                                <ClearIcon
                                  style={{
                                    opacity: this.state.searchText
                                      ? 1
                                      : 0.4,
                                    fontSize: "1.25rem",
                                    color: "353538",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="table-responsive paginationTable">
                <table className="table text-start table-hover">
                  <thead className="paginationTableThead">
                    <tr>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("name")}
                      >
                        Group Name
                        {this.state.sortColumn === "name" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th
                        scope="col fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSort("count")}
                      >
                        Group Contacts
                        {this.state.sortColumn === "count" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th
                        className="cursor-pointer"
                        scope="col fw-bold"
                        onClick={() => this.handleSort("updatedOn")}
                      >
                        Last Saved
                        {this.state.sortColumn === "updatedOn" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("createdby")}>Group Owner
                        {this.state.sortColumn === "createdby" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th
                        scope="col fw-bold"
                      > &nbsp;
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.smsGroupList?.map((rowData, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            rowData.id === this.state.groupId
                              ? "#FEF5E7"
                              : "",
                        }}
                      >

                        <td
                          style={{ width: "180px" }}
                          onClick={(e) =>
                            this.toGroupDetails(e, rowData, index)
                          }
                        >
                          <span
                            className="anchortag action-text"
                            onClick={(e) => this.toGroupDetails(e, rowData)}
                          >
                            {rowData.name}
                          </span>
                        </td>
                        <td
                          style={{ width: "180px" }}
                        >
                          {rowData.count}
                        </td>
                        <td
                          style={{ width: "180px" }}
                        >
                          {rowData.updatedOn}
                        </td>
                        <td
                          style={{ width: "180px" }}
                        >
                          {rowData.createdby}
                        </td>
                        <td
                          key={rowData.id}
                          style={{ width: "80px" }}
                        >
                          <div className="row d-flex" style={{ float: "center" }}>
                            <div className="col-md-12 d-flex">
                              {this.state.getUpdatePermission && (
                                <span style={{ cursor: "pointer" }}>
                                  <EditButton onClick={() => this.handleEditGroupOpen(rowData)} />
                                </span>
                              )}
                              <span className="ps-2" style={{ cursor: "pointer" }}>
                                {this.state.getDeletePermission && (
                                  <Tooltip title="Delete" classes={{ popper: "custom-tooltip" }}>
                                    <DeleteButton
                                      domainObject={rowData.name}
                                      pageId="Group"
                                      onClick={() => this.deleteGroupToBackend(rowData)}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {this.state.totalRecords === 0 && (
                <div
                  className="row text-center"
                  style={{ padding: "6px 20px" }}
                >
                  <h5 className="dataNotAvailable">
                    There are no groups yet.
                  </h5>
                </div>
              )}
              {this.state.totalRecords > 10 && (
                <div className="row justify-content-between pagination p-1">
                  <div className="d-flex col-12 col-lg-4 col-xl-4">
                    <div className="pageSize col-12 text-start">
                      Page {this.state.pageNo + 1} of{" "}
                      {this.state.totalPages}
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-8 col-xl-8">
                    <div className="col-12 text-end">
                      <Pagination
                        showPerPage={this.state.showPerPage}
                        onPaginationChange={this.onPaginationChange.bind(
                          this
                        )}
                        total={this.state.totalRecords}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div >

        <Dialog
          open={this.state.isImportOpen}
          onClose={this.handleImportDropdownClose}
          maxWidth="xl"
          className="importContactDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Import Contacts</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleImportDropdownClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div className="row pt-3">
              {this.accountSettings?.enableImport ? (
                <div className="col-sm-12">
                  <div className="groupCustom-steps">
                    <div className="groupCustom-step">
                      <div className="row d-flex">
                        <div className="col-sm-12">
                          <label>
                            <a
                              href={SmsContactImportFile}
                              style={{
                                color: "#1957b4",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                              id="dwnlink"
                              download="GivBee_Optin_List_Upload_Template.CSV"
                            >
                              <u>Download our CSV template</u>
                            </a> Use this CSV template for uploading. <span style={{ fontSize: "13px" }}>(required)</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <ValidatorForm
                      className="text-start"
                      ref="form"
                      onSubmit={this.excelImportContactToGroup.bind(this)}
                    >
                      <div className="groupCustom-step">
                        <div className="row mb-1 mt-4">
                          {this.state.selectedFile?.name === "" ?
                            <div
                              className="col-sm-7 d-flex csvFile"
                              style={{ display: "inline-block", cursor: "pointer" }}
                            >
                              <div className="file-upload-wrapper">
                                <label
                                  htmlFor="import-csvfile"
                                  className={`customImageVideo-file-upload ${this.state.isDragging ? "dragging" : ""
                                    }`}
                                  onDrop={this.handleDrop}
                                  onDragOver={this.handleDragOver}
                                  onDragLeave={this.handleDragLeave}
                                >
                                  <CloudUploadIcon className="upload-icon" />
                                  <span className="upload-text">
                                    Drop or{" "}
                                    <span className="browse-link">browse CSV files here</span>
                                  </span>

                                  <input
                                    required
                                    id="import-csvfile"
                                    type="file"
                                    accept=".csv"
                                    ref={this.fileUploadRef}
                                    onChange={this.handleFileChange}
                                  />
                                </label>

                                {/* <small className="upload-note">
                                  {this.state.selectedFile?.name === ""
                                    ? "Choose CSV file"
                                    : Utils.truncateString(this.state.selectedFile?.name, 60)}
                                </small> */}
                              </div>
                            </div>
                            :
                            <div
                              className="col-sm-12 d-flex csvFile"
                              style={{ display: "inline-block", cursor: "pointer" }}
                            >
                              <div className="align-content-center" style={{ height: "76.61px" }}>
                                <p
                                  className="mb-0 anchortag"
                                  id="fileLabel"
                                  style={{ display: "inline" }}
                                >
                                  {this.state.selectedFile?.name === ""
                                    ? ""
                                    : Utils.truncateString(this.state.selectedFile?.name, 60)}
                                </p>
                                <span className="fw-bold ms-2">
                                  <ClearIcon
                                    className="logoDelete"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      border: "solid 2px",
                                      color: "#697a8d",
                                    }}
                                    onClick={this.cancelImportExcelFile.bind(
                                      this
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="groupCustom-step">
                        <div className="row mt-3" style={{ height: "60px" }}>
                          <div className="col-md-6">
                            <label
                              className="MuiAutocomplete-label form-label"
                              htmlFor="collapsible-supplierType"
                            >
                              Import into group
                            </label>
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              ListboxProps={{
                                className: "custom-listbox",
                              }}
                              options={this.state.importSmsGroupList}
                              value={this.state.groupsName}
                              getOptionLabel={(option) => option.name}
                              defaultValue={this.state.groupsName}
                              onChange={(event, value) => {
                                this.handleGroupsNameChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  required
                                  title=""
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                          {this.state.iscreateGroup && (
                            <div className="col-md-6">
                              <label
                                className="form-label"
                                htmlFor="collapsible-supplierType"
                              >
                                Group Name
                              </label>
                              <input
                                title=""
                                required
                                type="text"
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control"
                                value={this.state.groupName}
                                onChange={this.handleGroupNameChange.bind(this)}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="groupCustom-step">
                        <div className="row d-flex" style={{ marginTop: "1.5em" }}>
                          <span className="me-3 importCheckboxSize pt-1">
                            <FormControlLabel
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                marginTop: -4,
                                paddingLeft: "10px",
                                marginRight: "0",
                              }}
                              control={
                                <Checkbox
                                  variant="outlined"
                                  id="isAsset"
                                  checked={this.state.checkCSVFile}
                                  value={this.state.checkCSVFile}
                                  onChange={this.checkCSVFilekHandler.bind(this)}
                                  style={{
                                    padding: 0,
                                    // marginTop: -2,
                                    marginRight: "8px",
                                    background: "none",
                                  }}
                                />
                              }
                              label={
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "0.9375rem" }}
                                >
                                  On behalf of{" "}
                                  {this.companyName ? this.companyName : ""}, I
                                  verify that all persons on the selected list have
                                  given permission to be added to the opt-in list
                                  for this account.
                                </Typography>
                              }
                            />
                          </span>
                        </div>
                      </div>
                      <div className="row mt-3 align-items-center">
                        <div class="col-md-12 text-center ps-3">
                          {this.state.checkCSVFile &&
                            this.state.selectedFile?.name !== "" ? (
                            <Button
                              id="ptsButton"
                              type="submit"
                            // style={{
                            //   background: "#b6bec8",
                            // }}
                            >
                              Import
                            </Button>
                          ) : (
                            <Button disabled id="ptsButton" type="button">
                              Import
                            </Button>
                          )}
                        </div>
                      </div>
                    </ValidatorForm>
                    <div className="row mt-2" style={{ height: "25px" }}>
                      {this.state.isProgress && (
                        <LinearProgressWithLabel value={this.state.progress} />
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-sm-12">
                  <div className="row">
                    <span style={{ textAlign: "center" }}>
                      <p className="m-0" style={{ fontSize: "16px" }}>
                        Please contact customer support to activate this
                        feature.
                      </p>
                    </span>
                  </div>
                  <div className="row mt-3 align-items-center">
                    <div class="col-md-12 text-center">
                      <Button
                        id="ptsButton"
                        type="button"
                        style={{
                          background: "#b6bec8",
                        }}
                      >
                        Contact Customer support
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </DialogContent >
        </Dialog >
        <Dialog
          open={this.state.openSkippedNumbers}
          onClose={this.handleSkippedNumbersClose}
          maxWidth="xl"
          className="importContactDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Skipped Numbers</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleSkippedNumbersClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div className="row p-2">
              <p className="ps-2">{this.state.skippedNumbers?.length} contacts can not be imported for the following reasons.</p>
              {this.state.skippedNumbers &&
                this.state.skippedNumbers.length > 0 ? (
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "60px",
                          fontSize: "14px",
                        }}
                      >
                        #
                      </th>
                      <th
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                        }}
                      >
                        Reason
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.skippedNumbers.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ color: "red" }}>{item}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="text-center text-muted">
                  No skipped numbers found.
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.isImportDisableOpen}
          onClose={this.handleImportDisableClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <div className="row">
              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "16px" }}>
                  Please contact customer support to activate this feature.
                </p>
              </span>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              // marginTop: "1em",
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              type="button"
              size="large"
              style={{
                background: "#37517e",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              // startIcon={<SaveIcon />}
              onClick={this.requestActivateImportContact.bind(this)}
            >
              Contact Customer Support
            </Button>
            <Button
              variant="contained"
              size="large"
              type="button"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleImportDisableClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="importContactDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>
              {this.state.action === "create" ? "Add Group" : "Edit Group"}
            </span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={
              this.state.action === "create"
                ? this.createGroupToBackend.bind(this)
                : this.updateGroupToBackend.bind(this)
            }
          >
            <DialogContent className="pb-4">
              <div className="row d-flex justify-content-center">
                <div className="col-md-9">
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold align-self-center"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Group Name
                    </label>
                    <div className="col-sm-8" id="givbeeText">
                      <input
                        title=""
                        required
                        autoFocus={true}
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.groupName}
                        onChange={this.handleGroupNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  {this.state.action === "edit" &&
                    <div className="row mt-3">
                      <label
                        className="col-sm-4 col-form-label fw-bold align-self-center"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Created By
                      </label>
                      <div className="col-sm-8" id="givbeeText">
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          autoComplete="off"
                          ListboxProps={{
                            className: "custom-listbox",
                          }}
                          options={this.state.userList}
                          value={this.state.groupCreatedBy}
                          getOptionLabel={(option) => option.name}
                          defaultValue={this.state.groupCreatedBy}
                          onChange={(event, value) => {
                            this.handleGroupCreatedByChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              title=""
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="autoComplete"
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </DialogContent>
            <DialogActions className="justify-content-center p-4">
              <div className="row d-flex justify-content-center">
                <div className="col-sm-12 text-start align-self-center">
                  <CreateButton btnName="Create" type="submit" />
                  &nbsp;&nbsp;
                  <CancelIconButton
                    btnName="Cancel"
                    onClick={(e) => this.handleClose()}
                  />
                </div>
              </div>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
      </>
    );
  }
}

export default withRouter(GroupList);
